import { DocumentBulkUploadResult } from 'mapistry-shared';
import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateOrganizationDocumentsCache,
  OrganizationDocumentsCacheEvents,
} from '@monorepo/shared/cacheRegisters/documents/organizationDocumentsCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseUploadOrganizationDocumentsParams = {
  config?: MutationConfig<DocumentBulkUploadResult, Api.ErrorResponse>;
};

export const useUploadOrganizationDocuments = (
  params?: UseUploadOrganizationDocumentsParams,
) =>
  useMutation(Api.uploadOrganizationDocuments, {
    ...params?.config,
    onSuccess: (data, vars) => {
      invalidateOrganizationDocumentsCache(
        OrganizationDocumentsCacheEvents.CREATE,
        {
          organizationId: vars.organizationId,
          folderId: vars.folderId,
        },
      );
      return params?.config?.onSuccess?.(data, vars);
    },
  });
